import {MARKERERROR} from './MarkerErrorTypes'

export const changeMarkerError = markerError => {
    return {
        type: MARKERERROR,
        load: markerError
    }
}
export const selectNewMarkerError = (markerError) => {

    return (dispatch) => {
        dispatch(changeMarkerError(markerError))
    }

}